export const formatSalesValue = (value) => {
    const num = parseFloat(value);
    if (isNaN(num) || num === 0) return 0;
    return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};
